import './scaleIcon.css';

export default function ScaleIcon() {
    return(
        <div className="scale-icon">
            <svg width="178.929" height="44.732" viewBox="0 0 178.929 44.732">
                <path id="Icon_material-twotone-linear-scale" data-name="Icon material-twotone-linear-scale" d="M159.563,14.25a22.383,22.383,0,0,0-20.487,13.42H112.952a22.349,22.349,0,0,0-40.975,0H45.854a22.366,22.366,0,1,0,0,17.893H71.977a22.349,22.349,0,0,0,40.975,0h26.124A22.362,22.362,0,1,0,159.563,14.25Z" transform="translate(-3 -14.25)" fill="#88cdf6"/>
            </svg>
        </div>
    )
}